/**
 * Native <option> element.
 *
 */

import React from 'react';

const SelectOption = ({ value, label, children }) => {
  return (
    <option value={value}>
      {children || label}
    </option>
  );
};

export default SelectOption;



/** WEBPACK FOOTER **
 ** ./src/components/SelectOption/SelectOption.js
 **/